pageId = 'teams-external_apps-index'
page = "##{ pageId }"

$(document).on 'pjaxload#' + pageId, (e, $page, page) ->
  $('#link-wechat-app').on 'click', ->
    simple.dialog
      content: $('#tpl-apps-wechat').html()
      width: 340
      modal: true
      buttons: null

  $('#link-api-app').on 'click', ->
    simple.dialog
      content: $('#tpl-apps-api').html()
      modal: true
      buttons: null

  $('#link-lanhu-app').on 'click', ->
    simple.dialog
      content: $('#tpl-apps-lanhu').html()
      width: 550
      modal: true
      buttons: null
